/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {PaymentListPageComponent} from './payment-list-page.component';

@Component({
  standalone: true,
  imports: [PaymentListPageComponent],
  selector: 'adn-payment-route-page',
  template: '<adn-payment-list-page></adn-payment-list-page>'
})
export class PaymentRoutePageComponent {}
